import React from "react";
import { Box, CircularProgress, Fade } from "@mui/material";

export default function GlassLoaderOverlay({ open = false }) {
  return (
    <Fade in={open} timeout={500} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backdropFilter: "blur(12px) saturate(150%) brightness(0.9)",
          background: "rgba(255, 255, 255, 0.08)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1300,
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress
            size={72}
            thickness={4.5}
            sx={{
              color: "transparent",
              background:
                "conic-gradient(from 180deg at 50% 50%, #00D4FF, #0061FF, #00D4FF)",
              borderRadius: "50%",
              mask: "radial-gradient(farthest-side, transparent calc(100% - 6px), black 0)",
              WebkitMask:
                "radial-gradient(farthest-side, transparent calc(100% - 6px), black 0)",
              animation: "spin 1.2s linear infinite",
              "@keyframes spin": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            }}
          />

          <Box
            sx={{
              color: "#fff",
              fontSize: "1rem",
              fontWeight: 500,
              letterSpacing: 0.5,
              textShadow: "0 0 6px rgba(0,0,0,0.4)",
            }}
          >
            Loading, please wait...
          </Box>
        </Box>
      </Box>
    </Fade>
  );
}